import React, { isValidElement } from 'react';

export const normalizeIcon = (icon) => {
  if (isValidElement(icon)) {
    return icon;
  }

  if (typeof icon === 'string') {
    return <img src={icon} alt="ico" />;
  }
  return null;
};
